import {BookingStepBase} from "./booking-step.base";
import {IBookingRoutes} from "../../../navigation/routes/booking/booking.routes.interface";

export abstract class BookingFlowStepBase extends BookingStepBase {
    protected get routes(): IBookingRoutes {
        return this.services.navigator.routes.booking;
    }
}
